<template>
  <nav class="login-reminder flex justify-center items-center space-x-5">
    <!-- Login Link -->
    <router-link v-if="!isLoggedIn" :to="{ path: `/${$systemPath('login')}`, query: { redirect: $route.fullPath } }"
      class="flex items-center space-x-2 transition text-gray-400 hover:text-gray-500">
      <font-awesome-icon :icon="['fas', 'user']" class="text-lg" />
      <span class="text-lg">{{ $translate('Login') }}</span>
    </router-link>

    <!-- Register Button -->
    <router-link v-if="!isLoggedIn" :to="{ path: `/${$systemPath('register')}` }" :class="[
      'flex items-center space-x-2 px-6 py-2 font-semibold rounded-full transition-transform transform hover:scale-105 shadow-lg',
      getColor(500, 'bg'),
      getColor(600, 'hover:bg'),
      'text-white'
    ]">
      <font-awesome-icon :icon="['fas', 'user-plus']" class="text-lg" />
      <span class="text-lg">{{ $translate('Register') }}</span>
    </router-link>

    <!-- User Card if Logged In -->
    <div v-if="isLoggedIn" class="user-card flex items-center space-x-4 relative" ref="dropdownContainer">
      <div @click="toggleDropdown" class="flex items-center space-x-4 cursor-pointer relative">
        <div class="relative">
          <img :src="user.avatar" alt="User Avatar" class="w-10 h-10 rounded-full shadow-md" />
          <span v-if="user.status == 'Online'"
            class="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
        </div>
        <div class="flex flex-col">
          <span class="leading-none font-semibold text-blue-500">{{ user.full_name }}</span>
          <span v-if="user.role" class="text-sm text-blue-400">{{ user.role }}</span>
          <span v-else class="italic text-yellow-500">{{ $translate('Unfilled') }}</span>
        </div>
        <font-awesome-icon icon="ellipsis-v" class="pl-2 text-lg text-gray-600"></font-awesome-icon>
      </div>

      <!-- Dropdown Menu -->
      <div v-if="dropdownOpen" class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20"
        style="top: 100%; margin-top: 0.5rem;">
        <ul class="py-2 text-sm text-gray-700">
          <li @click="goToAccountSettings" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            {{ $translate('Settings') }}</li>
          <li @click="goToPayments" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            {{ $translate('Payments & Invoices') }}</li>
          <li @click="goToBillingAddress" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            {{ $translate('Billing Address') }}</li>
          <li @click="goToPreferences" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            {{ $translate('Preferences') }}</li>
          <li @click="goToContactUs" class="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            {{ $translate('contact_us') }}
          </li>
          <li @click="handleLogout" class="px-4 py-2 text-red-600 hover:bg-red-100 cursor-pointer">{{
            $translate('Logout') }}</li>
        </ul>
      </div>
    </div>
  </nav>
</template>



<script>
//import { getSystemPath } from '@/utils/helper';
import { getUserData, logout } from '@/utils/cookie';
//import { computed } from 'vue';
import { getSystemPath } from '@/utils/helper';
import { useRouter } from 'vue-router';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { get } from 'lodash';

export default {
  name: 'AuthModule',
  props: {
    event: {
      type: Object,
      required: false,
    },
    attendee: {
      type: Object,
      required: false,
    },
    isSignedUp: {
      type: Boolean,
      required: false,
    },
    eventType: {
      type: Object,
      required: false,
    },
    getColor: {
      type: Function,
      required: false,
      default: (shade = 500, prefix = 'text') => `${prefix}-${shade}`
    },
  },
  setup(props) {
    //  const eventType = computed(() => getEventType(props.eventType));
    const getColorClass = get(props, 'getColor', (shade = 500, prefix = 'text') => `${prefix}-${shade}`);
    const router = useRouter();
    const dropdownOpen = ref(false);
    const dropdownContainer = ref(null);



    const toggleDropdown = () => {
      dropdownOpen.value = !dropdownOpen.value;
    };

    const goToAccountSettings = () => {
      closeDropdown();
      router.push({ path: `/${getSystemPath('account')}/${getSystemPath('settings')}` });
    };

    const goToPayments = () => {
      closeDropdown();
      router.push({ path: `/${getSystemPath('account')}/${getSystemPath('payments')}` });
    };

    const goToBillingAddress = () => {
      closeDropdown();
      router.push({ path: `/${getSystemPath('account')}/${getSystemPath('billingAddress')}` });
    };

    const goToPreferences = () => {
      closeDropdown();
      router.push({ path: `/${getSystemPath('account')}/${getSystemPath('preferences')}` });
    };

    const goToContactUs = () => {
      closeDropdown();
      router.push({ path: `/${getSystemPath('legal')}/${getSystemPath('contact')}` });
    };

    const handleLogout = () => {
      logout();
      closeDropdown();
      router.push({ path: `/${getSystemPath('login')}` });
    };

    const closeDropdown = () => {
      dropdownOpen.value = false;
    };

    const handleClickOutside = (event) => {
      if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
        closeDropdown();
      }
    };

    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      getColorClass,
      toggleDropdown,
      goToAccountSettings,
      goToPayments,
      goToBillingAddress,
      goToPreferences,
      goToContactUs,
      handleLogout,
      dropdownContainer,
      dropdownOpen,
    };


  },
  data() {
    return {
      isLoggedIn: false,
      user: {}
    };
  },
  mounted() {
    const user = getUserData();
    if (user && user.type == 'partner') {
      this.isLoggedIn = true;
      this.user = user;
    }
  },

}
</script>

<style scoped>
.user-card {
  color: #ddd;
}

.user-card img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
}

.membership-badge {
  background-color: #4CAF50;
  color: white;
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  margin-left: 0.5rem;
}

.logout-icon {
  font-size: 0.7rem;
}

.logout:hover .logout-icon {
  color: rgb(252 165 165);
}

.logout:hover span {
  color: rgb(252 165 165);
}
</style>
